module.exports = __webpack_public_path__ + "img/House.0c0375f8.svg";